import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children"];
import styled from 'foundations-theming/utils';
import { forwardRef } from 'react';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { deepMerge } from '../../../transitional/utils/deepMerge/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledView = styled.div.withConfig({
  displayName: "View__StyledView",
  componentId: "w1zifm-0"
})(props => {
  const $cssStyles = props.$cssStyles;
  const $styleOverrides = props.$styleOverrides;
  return deepMerge(Object.assign({}, $cssStyles), $styleOverrides !== null && $styleOverrides !== void 0 ? $styleOverrides : {});
});

/**
 * `View` is a primitive layout component that provides access to the
 * style props defined in the design system alongside many of our
 * token values.
 *
 */
export const View = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as = 'div',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledView, Object.assign({}, domProps, callbackProps, {
    as: as,
    $cssStyles: cssStyles,
    ref: ref // Styled Components expects a `div` ref even though we pass the `as` prop
    ,
    children: children
  }));
});
View.displayName = 'View';